import { Component } from 'react';
import {connect} from 'react-redux';
import {actions, Errors, Form} from 'forms/rrf';
import {Col, Container, Row} from 'react-bootstrap';
import PageTitle from '../common/page-title/index';
import RequiredPasswordMaskInput from '../common/form/elements/required-password-mask-input';
import ArrowButton from '../common/button-arrow';
import ErrorMessages from '../login/error-messages';
import {updateMyPassword} from '../../actions/update-password';

import './update-password.css';
import {USER_TYPE_REP} from '../../data/userTypes';
import {currentUserGroup} from '../../utils/tokenUtils';

const exemptFromSymbolCheck = () => ['owner', 'staff'].includes(currentUserGroup());

class UpdatePassword extends Component {
  state = {};

  updateErrors = (field, value) => {
    this.setState({[field]: value});
  };

  onChangeMyPasswordClicked = (payload) => {
    const {area, dispatch} = this.props;
    const redirectUrl = area === USER_TYPE_REP ? '/team/my-profile' : '/my-profile';
    dispatch(actions.submitFields('deep.updatePw.user', updateMyPassword(payload, redirectUrl)));
  };

  render() {
    return (
      <Container className="user-inner-container update-password" fluid>
        <Row>
          <Col lg={12} className="update-password-title">
            <PageTitle>
              Update password
            </PageTitle>
          </Col>
        </Row>

        <Form
          className="update-password-form"
          model="deep.updatePw.user"
          onSubmit={this.onChangeMyPasswordClicked}
        >

          <Errors
            className="errors"
            component={ErrorMessages}
            model="deep.updatePw.user"
            show={{
              touched: true,
              focus: false
            }}
          />
          <Row>
            <Col lg={12}>
              <h5>
                The password must be a minimum of 8 characters and contain one uppercase, one
                lowercase,
                {' '}
                {exemptFromSymbolCheck() ? 'and one number.' : 'one number and one symbol (e.g.@*&/).'}
              </h5>
              <RequiredPasswordMaskInput
                controlId="currentPassword"
                label="Current Password"
                model=".current_password"
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <RequiredPasswordMaskInput
                controlId="newPassword"
                label="New Password"
                model=".password"
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <RequiredPasswordMaskInput
                controlId="confirmNewPassword"
                label="Confirm New Password"
                model=".password_confirmation"
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12} className="update-password-button-container">
              <ArrowButton
                arrow={false}
                className="float-end"
                color="red"
              >
                Change my password
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </Container>
    );
  }
}

export default connect()(UpdatePassword);
